<template>
  <div class="products-page">
    <!-- 页面头部 -->
    <div class="page-header">
      <div class="container">
        <el-row>
          <h1 style="width: 100%">核心业务</h1>
        </el-row>
        <el-row>
          <div class="breadcrumb">
            <el-breadcrumb separator="/">
              <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
              <el-breadcrumb-item>核心业务</el-breadcrumb-item>
            </el-breadcrumb>
          </div>
        </el-row>


      </div>
    </div>

    <div class="container container2">
      <!-- 产品分类菜单 -->
      <div class="product-category">
        <el-menu
            :default-active="activeCategory"
            class="category-menu"
            @select="handleCategorySelect">
          <el-menu-item index="all">信息化项目造价咨询</el-menu-item>
          <el-menu-item index="budget-software">工程项目造价咨询</el-menu-item>
          <el-menu-item index="cost-control">信息化全过程咨询</el-menu-item>
          <el-menu-item index="data-analysis">工程咨询</el-menu-item>
        </el-menu>
      </div>

      <!-- 产品列表 -->
      <div class="product-list">
        <el-row :gutter="30">
          <el-col :xs="24" :sm="12" :md="8" :lg="6" v-for="(product, index) in filteredProducts" :key="index">
<!--            @click.native="showProductDetail(product)"-->
            <el-card class="product-card" shadow="hover" >
<!--              <div class="product-img">-->
<!--                <img :src="product.image" :alt="product.name">-->
<!--              </div>-->
              <div class="product-info">
                <h3>{{ product.name }}</h3>
                <p>{{ product.shortDescription }}</p>
              </div>
            </el-card>
          </el-col>
        </el-row>

        <!-- 分页 -->
        <div class="pagination-container">
          <el-pagination
              background
              layout="prev, pager, next"
              :total="totalProducts"
              :page-size="pageSize"
              :current-page.sync="currentPage"
              @current-change="handlePageChange">
          </el-pagination>
        </div>
      </div>
    </div>

    <!-- 产品详情对话框 -->
    <el-dialog
        :title="selectedProduct.name"
        :visible.sync="dialogVisible"
        width="70%">
      <div class="product-detail" v-if="selectedProduct.id">
        <div class="detail-image">
          <img :src="selectedProduct.image" :alt="selectedProduct.name">
        </div>
        <div class="detail-info">
          <h2>{{ selectedProduct.name }}</h2>
          <div class="detail-category">
            <span>产品类别: </span>
            <el-tag size="small">{{ selectedProduct.category }}</el-tag>
          </div>
          <div class="detail-description">
            <h3>产品描述</h3>
            <p>{{ selectedProduct.description }}</p>
          </div>
          <div class="detail-features">
            <h3>产品特点</h3>
            <ul>
              <li v-for="(feature, index) in selectedProduct.features" :key="index">
                <i class="el-icon-check"></i> {{ feature }}
              </li>
            </ul>
          </div>
          <div class="detail-specs" v-if="selectedProduct.specifications">
            <h3>技术参数</h3>
            <el-table :data="selectedProduct.specifications" style="width: 100%">
              <el-table-column prop="name" label="参数名称" width="180"></el-table-column>
              <el-table-column prop="value" label="参数值"></el-table-column>
            </el-table>
          </div>
          <div class="detail-actions">
            <el-button type="primary" icon="el-icon-document" @click="downloadProductDoc">
              下载产品资料
            </el-button>
            <el-button icon="el-icon-message" @click="goToContact">
              咨询产品
            </el-button>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'Products',
  data() {
    return {
      activeCategory: 'all',
      currentPage: 1,
      pageSize: 8,
      dialogVisible: false,
      selectedProduct: {},
      products: [
        // 信息化项目造价咨询
        {
          id: 1,
          name: '信息化项目预算编制',
          category: 'all',
          image: '/img/038.png'
        },
        {
          id: 2,
          name: '信息化项目结算审计',
          category: 'all',
          image: '/img/039.png'
        },
        {
          id: 3,
          name: '信息化项目控制价评审',
          category: 'all',
          image: '/img/040.png'
        },
        // 工程项目造价咨询
        {
          id: 4,
          name: '工程项目预算编制',
          category: 'budget-software',
          image: '/img/038.png'
        },
        {
          id: 5,
          name: '工程项目结算审计',
          category: 'budget-software',
          image: '/img/039.png'
        },
        {
          id: 6,
          name: '工程项目控制价评审',
          category: 'budget-software',
          image: '/img/040.png'
        },
        // 信息化全过程咨询
        {
          id: 7,
          name: '信息化项目监理',
          category: 'cost-control',
          image: '/img/038.png'
        },
        {
          id: 8,
          name: '信息化项目验收',
          category: 'cost-control',
          image: '/img/039.png'
        },
        {
          id: 9,
          name: '定制化软件开发',
          category: 'cost-control',
          image: '/img/040.png'
        },
        // 工程咨询
        {
          id: 10,
          name: '资金申请报告',
          category: 'data-analysis',
          image: '/img/038.png'
        },
        {
          id: 11,
          name: '绩效评价报告',
          category: 'data-analysis',
          image: '/img/039.png'
        },
        {
          id: 12,
          name: '可行性研究报告',
          category: 'data-analysis',
          image: '/img/040.png'
        },,
        {
          id: 13,
          name: '投资效益分析报告',
          category: 'data-analysis',
          image: '/img/040.png'
        }
      ]
    }
  },
  computed: {
    totalProducts() {
      // if (this.activeCategory === 'all') {
      //   return this.products.length
      // } else {
        return this.products.filter(product => product.category === this.activeCategory).length
      // }
    },
    filteredProducts() {
      let result = this.products

      // if (this.activeCategory !== 'all') {
        result = result.filter(product => product.category === this.activeCategory)
      // }

      // 计算分页
      const startIndex = (this.currentPage - 1) * this.pageSize
      const endIndex = startIndex + this.pageSize
      return result.slice(startIndex, endIndex)
    }
  },
  methods: {
    handleCategorySelect(key) {
      this.activeCategory = key
      this.currentPage = 1
    },
    handlePageChange(page) {
      this.currentPage = page
    },
    showProductDetail(product) {
      this.selectedProduct = product
      this.dialogVisible = true
    },
    downloadProductDoc() {
      this.$message({
        message: '产品资料下载中，请稍候...',
        type: 'success'
      })
    },
    goToContact() {
      this.$router.push('/contact')
    }
  },
  created() {
    // 获取当前路由参数，设置默认分类
    const category = this.$route.query.category
    if (category) {
      this.activeCategory = category
    }
  }
}
</script>

<style lang="scss" scoped>
.el-col-lg-6 {
  width: 100%;
}

.products-page {
  padding-bottom: 60px;

  //.container {
  //  display: flex;
  //
  //  @media (max-width: 768px) {
  //    flex-direction: column;
  //  }
  //}
  .container2 {
    display: flex;

    @media (max-width: 768px) {
      flex-direction: column;
    }
  }

  .product-category {
    width: 200px;
    margin-right: 30px;

    @media (max-width: 768px) {
      width: 100%;
      margin-right: 0;
      margin-bottom: 20px;
    }

    .category-menu {
      border-radius: 4px;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    }
  }

  .product-list {
    flex: 1;

    .product-card {
      height: 100%;
      cursor: pointer;
      transition: all 0.3s;
      margin-bottom: 30px;

      &:hover {
        transform: translateY(-5px);
      }

      .product-img {
        height: 180px;
        overflow: hidden;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform 0.5s;
        }
      }

      &:hover .product-img img {
        transform: scale(1.05);
      }

      .product-info {
        padding: 15px;

        h3 {
          font-size: 16px;
          margin-bottom: 10px;
          height: 44px;
          overflow: hidden;
        }

        p {
          color: #666;
          font-size: 14px;
          height: 60px;
          overflow: hidden;
        }
      }
    }

    .pagination-container {
      text-align: center;
      margin-top: 30px;
    }
  }
}

// 产品详情样式
.product-detail {
  display: flex;

  @media (max-width: 768px) {
    flex-direction: column;
  }

  .detail-image {
    width: 100%;
    padding-right: 30px;

    @media (max-width: 768px) {
      width: 100%;
      padding-right: 0;
      margin-bottom: 20px;
    }

    img {
      width: 100%;
      border-radius: 4px;
    }
  }

  .detail-info {
    width: 100%;

    @media (max-width: 768px) {
      width: 100%;
    }

    h2 {
      font-size: 24px;
      margin-bottom: 10px;
      color: #333;
    }

    .detail-category {
      margin-bottom: 20px;

      span {
        color: #666;
      }
    }

    .detail-description,
    .detail-features,
    .detail-specs {
      margin-bottom: 20px;

      h3 {
        font-size: 18px;
        margin-bottom: 10px;
        color: #333;
        padding-bottom: 5px;
        border-bottom: 1px solid #eee;
      }

      p {
        color: #666;
        line-height: 1.6;
      }

      ul li {
        margin-bottom: 8px;
        color: #666;

        i {
          color: #1ebec8;
          margin-right: 8px;
        }
      }
    }

    .detail-actions {
      margin-top: 30px;
    }
  }
}

.page-header {
  background-image: url('/img/bg2.jpg');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  padding: 40px 0;
  color: #fff;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.1);
    z-index: 1;
  }

  .container {
    position: relative;
    z-index: 2;
  }

  h1 {
    margin: 0;
    font-size: 32px;
    font-weight: 500;
    color: #fff;
  }

  .breadcrumb {
    margin-top: 10px;
    
    .el-breadcrumb {
      font-size: 14px;
      
      .el-breadcrumb__item {
        .el-breadcrumb__inner {
          color: rgba(255, 255, 255, 0.8);
          
          &:hover {
            color: #fff;
          }
        }
        
        &:last-child {
          .el-breadcrumb__inner {
            color: #fff;
          }
        }
      }
    }
  }
}
</style> 